import { configureStore } from "@reduxjs/toolkit";
import rollingProductSlice from './Pages/rollingProduct/slice';

export const store = configureStore({
    reducer:{
        ...rollingProductSlice,
    }
})